// extracted by mini-css-extract-plugin
export default {"iOSSafeArea":"ydddM","unifiedSearchView":"tbglI"};